'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Calendar from '../../Calendar/index.js';
import { PickerContainer, InputWrap, Icon, Wrapper } from '../styles.css.js';
import { ECalendarStyle } from '../../Calendar/types.js';
import { EDatePicker } from '../type.js';
import { datetimeFormat, isValidDateFormat, calendarCombineType } from '../utils/dateTimeFormat.js';
import { CalendarIcon } from '../../Images/Calendar/Calendar.js';
import { ELanguage } from '../../Utils/constants.js';
import DateInput from '../../DateInput.tsx/index.js';
import useFloating from '../../hooks/useFloating/index.js';
import useClickAway from '../../hooks/useClickAway.js';
import '../../hooks/useMakeSearchable/types.js';
import '../../services/resumes/types.js';
import useDropdownAnimation from '../../hooks/useDropdownAnimation.js';

function CombinePicker(_a) {
    var defaultDate = _a.defaultDate, onChangeProps = _a.onChange, _b = _a.min, min = _b === void 0 ? new Date(1900, 0, 1) : _b, max = _a.max, _c = _a.type, type = _c === void 0 ? EDatePicker.date : _c, placeholder = _a.placeholder, _d = _a.hasError, hasError = _d === void 0 ? false : _d, onBlur = _a.onBlur, onFocus = _a.onFocus, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.langCode, langCode = _f === void 0 ? ELanguage.EN : _f, calendarConfig = _a.calendarConfig, _g = _a.isFlip, isFlip = _g === void 0 ? false : _g, _h = _a.isShowIcon, isShowIcon = _h === void 0 ? true : _h, rangeYears = _a.rangeYears;
    var _j = calendarConfig || {}, floatingConfig = _j.floatingConfig, _k = _j.placement, placement = _k === void 0 ? 'bottom-start' : _k, _l = _j.dropdownOffset, dropdownOffset = _l === void 0 ? 0 : _l;
    var _m = useState(defaultDate), date = _m[0], setDate = _m[1];
    var inputValue = date && datetimeFormat(date, type);
    var _o = useState(false), showCalendar = _o[0], setShowCalendar = _o[1];
    var _p = useFloating({
        placement: placement,
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: __assign({ offset: dropdownOffset, detectHidden: true, useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false }, (!isFlip ? undefined : { isFlip: isFlip }))
    }), refs = _p.refs, context = _p.context, FloatingPortal = _p.FloatingPortal;
    useClickAway(function () {
        setShowCalendar(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    var _q = useDropdownAnimation(showCalendar, context.placement), isMounted = _q.isMounted, dropdownStyles = _q.styles;
    var onShowCalendar = function () {
        if (disabled)
            return;
        setShowCalendar(function (state) { return !state; });
    };
    var onChange = function (date) {
        var timer = null;
        timer && clearTimeout(timer);
        if ((date && min && min > new Date(date)) || (date && max && max < new Date(date))) {
            onChangeProps && onChangeProps(null);
            setDate(null);
            setShowCalendar(false);
            return;
        }
        timer = setTimeout(function () {
            setDate(date);
            onChangeProps && onChangeProps(date);
            if (date instanceof Date) {
                setShowCalendar(false);
            }
        }, 0);
    };
    var onKeyDown = function (e) {
        if (e.key === 'Tab' || e.code === 'Tab') {
            setShowCalendar(false);
            onBlur && onBlur();
        }
    };
    /*
     * Update date after defaultDate updated
     * */
    useEffect(function () {
        // check invalid date, if not return null
        if (defaultDate) {
            var newDate = !isNaN(new Date(defaultDate).getTime()) ? new Date(defaultDate) : null;
            setDate(newDate);
        }
        else {
            setDate(null);
        }
    }, [defaultDate]);
    return (React__default.createElement(PickerContainer, null,
        React__default.createElement(InputWrap, { ref: refs.setReference, onKeyDown: onKeyDown },
            React__default.createElement(DateInput, { type: type, value: inputValue, placeholder: placeholder, onChange: onChange, onBlur: function (value) {
                    var isValid = value && isValidDateFormat(value, type);
                    if (!isValid) {
                        setDate(null);
                    }
                }, onFocus: function () {
                    setShowCalendar(true);
                    onFocus && onFocus();
                }, disabled: disabled, hasError: hasError, min: min, max: max, isShowIcon: isShowIcon }),
            isShowIcon && (React__default.createElement(Icon, { isIcon: true, onClick: onShowCalendar, position: 'absolute', outline: 'none' },
                React__default.createElement(CalendarIcon, { size: 20 })))),
        isMounted ? (React__default.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
            React__default.createElement(Wrapper, { ref: refs.setPopup, style: {
                    position: context.position,
                    left: context.x,
                    top: context.y,
                    display: context.isReferenceHidden ? 'none' : 'block'
                } },
                React__default.createElement("div", { style: dropdownStyles },
                    React__default.createElement(Calendar, { langCode: langCode, initDates: date ? [date] : null, min: min, max: max, type: calendarCombineType(type), pickerType: ECalendarStyle.single, calendarStyle: ECalendarStyle.single, handleDateClick: function (dates) {
                            if (dates && dates.length > 0) {
                                onChange(dates[0]);
                                return;
                            }
                            onChange(null);
                        }, rangeYears: rangeYears }))))) : null));
}

export { CombinePicker as default };
//# sourceMappingURL=CombinePicker.js.map
